import { render, staticRenderFns } from "./general-dropdown.vue?vue&type=template&id=4c7e196d&scoped=true"
import script from "./general-dropdown.vue?vue&type=script&lang=js"
export * from "./general-dropdown.vue?vue&type=script&lang=js"
import style0 from "./general-dropdown.vue?vue&type=style&index=0&id=4c7e196d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7e196d",
  null
  
)

export default component.exports